import { useMemo } from 'react';
import type {
  AllocationOfCostsChartResponseByCategory,
  CostByInitiativeResponse,
  CostVsBudgetChartResponse,
} from '../../../api/financials-client/financials-client.type';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { Charts as ChartsType } from '../../../store/financials-store/financials-store.type';
import { Chart as AllocationOfCostsChart } from './allocation-of-costs/chart';
import { Chart as CostByInitiativeChart } from './cost-by-initiative/chart';
import { Chart as CostVersusOutputChart } from './cost-versus-output/chart';

interface ChartsProps {
  allocationOfCostsData?: AllocationOfCostsChartResponseByCategory;
  costByInitiativeData?: CostByInitiativeResponse[];
  costVersusOutputData?: CostVsBudgetChartResponse;
  isPending: boolean;
}

function Charts({ allocationOfCostsData, costByInitiativeData, costVersusOutputData, isPending }: ChartsProps) {
  const selectedChart = useFinancialsStore((state) => state.chart);

  const chart = useMemo(() => {
    switch (selectedChart) {
      case ChartsType.CostVersusOutput:
        return <CostVersusOutputChart data={costVersusOutputData} isPending={isPending} />;
      case ChartsType.AllocationOfCosts:
        return <AllocationOfCostsChart data={allocationOfCostsData} isPending={isPending} />;
      default:
        return <CostByInitiativeChart data={costByInitiativeData} isPending={isPending} />;
    }
  }, [selectedChart, allocationOfCostsData, costByInitiativeData, costVersusOutputData, isPending]);

  return <div style={{ width: '100%', height: '90%' }}>{chart}</div>;
}

export { Charts };
